import type { CSSProperties, FC, ReactNode } from 'react'
import type { BlobShape } from '@/lib/shapes'

import { cn } from '@/lib/utils'
import { Sticker } from '@/components/generals/sticker'

interface SectionHeadingProps {
    id: string
    lines: string[]
    sticker: string
    stickerShape?: BlobShape
    stickerColor?: string
    stickerClassName?: string
    align?: 'center' | 'left'
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    lines,
    sticker,
    stickerShape = 'flower',
    stickerColor = 'text-mint',
    stickerClassName,
    align = 'center',
    className
}): ReactNode => {
    return (
        <div className={cn('relative', align === 'center' ? 'mx-auto max-w-4xl text-center' : 'max-w-3xl', className)}>
            <h2
                id={id}
                className='relative inline-block font-heading text-[clamp(2.75rem,7.2vw,6.25rem)] leading-[0.92] tracking-[-0.005em]'
            >
                {lines.map((line, index) => (
                    <span
                        key={line}
                        className='reveal block'
                        style={{ '--reveal-delay': `${index * 140}ms` } as CSSProperties}
                    >
                        {line}
                    </span>
                ))}

                <Sticker
                    label={sticker}
                    shape={stickerShape}
                    colorClassName={stickerColor}
                    className={cn(
                        'reveal-pop absolute -top-9 -left-6 size-20 -rotate-12 text-[0.95rem] [--reveal-delay:320ms] motion-safe:animate-float sm:-top-10 sm:-left-14 sm:size-24 sm:text-lg',
                        stickerClassName
                    )}
                />
            </h2>
        </div>
    )
}
